let locationsData = [
 {
  shopId: 'sushime',
  id: 'sushime',
  instagram: "sushi_.yu",
  basePath: "/alhambra", 
  cssGlobalPrefix: 'pablitoschicken dark-mode',
  mapLogo: 'https://afag.imgix.net/sushi-yu/logo-round.png?w=100&auto=format',
  // disabled: true, openingDate: "visit/call to order",
  label: "Alhambra",
  className: 'night',
  address: ["115 W Main St", "Alhambra, CA 91801"],
  phone: "(626) 943-7872",
  phoneLink: "+16269437872",
  orderLink: "/alhambra/order",
  lat: 34.0944399, lng:-118.128288,
  storefrontPhoto: "https://afag.imgix.net/sushi-yu/storefront.png?w=600&auto=format",
  hours: [
    { day: 'ALL WEEK', hours: '11am-10pm' },
  ]},
];


const siteData = {
  domain: "sushiyula.com",
  name: "Sushi Yu | Order Deliverry & Takeout in Alhambra, CA",
  shortName: "Sushi Yu",
  description: "Discover Sushi Yu in Alhambra — a local favorite for fresh sushi, omakase, sashimi, rolls & Japanese bento. Dine in or order takeout for authentic flavor & craft.",
  folderId: 'sushiyu',
  ogImage: "https://afag.imgix.net/sushi-yu/regular-8pcs-combo.jpg?w=1000&auto=format",
  iconRoot: "https://afag.imgix.net/sushi-yu/logo-round.png",
}

export { siteData };
export default locationsData;

